import { render, staticRenderFns } from "./CollapseWrapper.vue?vue&type=template&id=d97ced1a&scoped=true"
import script from "./CollapseWrapper.vue?vue&type=script&lang=js"
export * from "./CollapseWrapper.vue?vue&type=script&lang=js"
import style0 from "./CollapseWrapper.vue?vue&type=style&index=0&id=d97ced1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97ced1a",
  null
  
)

export default component.exports